<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Centralny System Autoryzacji</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer class="app-footer">
      Problemy z zakładaniem konta, zmianą hasła należy zgłaszać na: / Issues
      with account creation, password changes please report to:
      <br />
      <a href="mailto:admin@umw.edu.pl">admin@umw.edu.pl</a>
      <br />
      Problemy techniczne w działaniu strony należy zgłaszać na: / Technical
      problems with site please report to:
      <br />
      <a href="mailto:csa@umw.edu.pl">csa@umw.edu.pl</a>
      <br />
      v2.8
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "Components",
  components: {},
  data: () => ({
    //
  }),
};
</script>
<style lang="scss"></style>
